// 分组类型字典
export const groupTypeDic = [
  { label: "防水", value: "WATERPROOF", color: "#409EFF" },
  { label: "回填", value: "BACKFILL", color: "#67C23A" },
  { label: "吊顶", value: "HANG_CEILING", color: "#E6A23C" },
];

export const userTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: true,
  showHeader: true,
  index: true,
  indexLabel: "序号",
  selection: true,
  menu: true,
  menuWidth: 180,
  page: true,
  addBtn: false,
  editBtn: false, // 改为弹窗编辑
  menuType: "text",
  delBtn: false,
  viewBtn: false,
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "分组名称",
      prop: "groupName",
      placeholder: "请输入分组名称",
      search: true,
      type: "input",
    },
    {
      label: "分组类型",
      prop: "type",
      type: "select",
      search: true,
      dicData: groupTypeDic.map((i) => ({ label: i.label, value: i.value })),
      formatter: (row) => {
        const item = groupTypeDic.find((i) => i.value === row.type);
        return item ? item.label : row.type || "-";
      },
    },
    {
      label: "排序",
      prop: "sort",
      type: "input",
      width: 80,
    },
  ],
};
